import React from "react";

class Page1 extends React.Component {
  state = {
    visible: true,
  };
  checkPageVisibility(pageNum) {
    if (pageNum == 1) {
      this.setState({
        visible: true,
      });
    } else {
      this.setState({
        visible: false,
      });
    }
  }
  render() {
    return (
      <div>
        {this.state.visible ? (
          <div className="container-fluid h-100 vertical-center ">
            <div className="row h-100 justify-content-center">
              <div className="col-lg-8 col-md-12 col-sm-12 col-xs-12">
                <div className="card mb-4 box-shadow" id="pageContent">
                  <div className="card-body d-flex flex-column text-dark">
                    <span id="moduleContentText_2">
                      Fantastic! You are ready for action which is great. In
                      this section, we will go through job / PhD application
                      timelines and we will provide you with an action plan of
                      what you need to do to ensure you secure your dream
                      opportunity.
                      <br />
                      <br />
                      The information in this section is focused on the UK job
                      market. We will demystify phrases you might have heard
                      such as ‘Graduate Schemes’ and ‘the hidden job market’. If
                      you are considering working outside of the UK you may find
                      the{" "}
                      <a
                        target="_blank"
                        href="https://www.prospects.ac.uk/jobs-and-work-experience/working-abroad"
                      >
                        ‘working abroad’
                      </a>{" "}
                      section on the Prospects site helpful.
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div></div>
        )}
      </div>
    );
  }
}

export default Page1;
